import { createElement } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";

export function errorMessage({ message, title }) {
  return sendMessage({ message, title, isError: true });
}

export function confirm({ message, title }) {
  return sendMessage({ message, title, isError: false });
}

const sendMessage = ({ message, title, isError }) => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);
    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 10);
    };
    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };
    const handleCancel = () => {
      cleanup();
      resolve(false);
    };
    root.render(
      createElement(ConfirmModal, {
        open: true,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        message,
        title,
        isError,
      })
    );
  });
};

export function ConfirmModal({ open, onConfirm, onCancel, message, title, isError }) {
  if (!open) return null;
  return (
    <Modal close={onCancel} size="small">
      <div className="modal-confirm-content">
        <div className="modal-header">{title}</div>

        <div className="modal-body">{message}</div>

        {isError ? (
          <div className="modal-footer center">
            <button className="btn blue" onClick={onConfirm}>
              Close
            </button>
          </div>
        ) : (
          <>
            <div className="modal-footer">
              <div className="btn-bar-left"></div>
              <div className="btn-bar-right">
                <button className="btn" onClick={onCancel}>
                  Cancel
                </button>
                <button className="btn blue ml-10" onClick={onConfirm}>
                  Confirm
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}
